module.exports = __webpack_public_path__ + "assets/img/title-db62e8f9.png";